/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Page Reports Constructor component
 *
 * @author Evgeniy Naumov
 * @version 1.22.0
 * @since 1.22.0
 */

import styled from 'styled-components';

import { colors } from '@theme/index';

export const ConstructorHeaderStyled = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ConstructorBasketWrapperStyled = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 64px;
    padding: 0 32px;
    background-color: ${colors.constructorBasketBg};
`;
export const ConstructorBasketStyled = styled.div`
    display: flex;
    align-items: flex-end;
`;

export const ConstructorBasketSelectedStyled = styled.span`
    line-height: 21px;
    opacity: 0.6;
    font-size: 12px;
    color: ${colors.constructorBasketSelected};
    padding-right: 0.5em;
`;

interface IConstructorBasketSubscribersStyled {
    empty: boolean;
}

export const ConstructorBasketSubscribersStyled = styled.span<IConstructorBasketSubscribersStyled>`
    padding-right: 0.5em;
    color: ${(props) => props.empty && colors.constructorBasketEmptySubs};
`;
